import Image from "next/image";
import { ElemenetType } from '../../lib/constants'
import { LeadPopUpButton } from '../shared/lead/LeadPopUpButton'
import styles from './Trends.module.css'
export function CompleteTurney(){
    return (
        <section className={`${styles.completeTurneyMain} `}>
        <div className={`${styles.bottomBookcounstion} knwldgeSection`}>
            <div className="container">
                <h2 className="text222 font26 mb46 textCenter">Complete Turnkey Services</h2>
                <div className={styles.bottomBookbox}>
                    <div className={styles.bottombookTiles}>
                    <LeadPopUpButton ElemenetType={ElemenetType.span}  ButtonClass={` `} >
                            <figure className={styles.bottombookimgBox}>
                                <div className={styles.default}>
                                    <Image
                                        className='img-responsive'
                                        width={176}
                                        height={141}
                                        src="/assets/images/CTA_Interior_Blank.svg"
                                        alt="interior_bottom"
                                        title="interior_bottom"
                                         />
                                </div>
                                <div className={styles.hover}>
                                    <Image
                                        className='img-responsive'
                                        width={176}
                                        height={141}
                                        src="/assets/images/CTA_interior.svg"
                                        alt="interiorImg"
                                         />  
                                </div>
                                <h3>Interior</h3>
                            </figure>
                   </LeadPopUpButton>
                    </div>
                    <div className={styles.bottombookTiles}>
                    <LeadPopUpButton ElemenetType={ElemenetType.span}  ButtonClass={` `} >
                            <figure className={styles.bottombookimgBox}>
                                <div className={styles.default}>
                                    <Image
                                        className='img-responsive'
                                        width={176}
                                        height={141}
                                        src="/assets/images/CTA_Construction_Blank.svg"
                                        alt="Desgin_bottom"
                                        title="Desgin_bottom"
                                         />
                                </div>
                                <div className={styles.hover}>
                                    <Image
                                        className='img-responsive'
                                        width={176}
                                        height={141}
                                        src="/assets/images/CTA_Construction.svg"
                                        alt="Construction"
                                         />  
                                </div>
                                <h3>Construction</h3>
                            </figure>
                            </LeadPopUpButton>
                    </div>
                    {/* <div className={styles.bottombookTiles}>
                        <LeadPopUpButton ElemenetType={ElemenetType.span}  ButtonClass={` `} >
                            <figure className={styles.bottombookimgBox}>
                                <div className={styles.default}>
                                        <Image className='img-responsive' width={176} height={141} src="/assets/images/CTA Renovation Blank.svg"  alt="Desgin_bottom"
                                        title="Desgin_bottom"/>
                                    </div>
                                    <div className={styles.hover}>
                                        <Image className='img-responsive' width={176} height={141} src="/assets/images/CTA Renovation.svg"  alt="Renovation"/>  
                                    </div>
                                <h3>Renovation</h3>
                            </figure>
                            </LeadPopUpButton>
                    </div> */}
                    <div className={styles.bottomCoustrtionltle}>
                        <div className={styles.coustrutionInnertile}>
                            <p>Every Home Has a
                                Unique Inside Story,
                                Talk To Our Designer</p>  
                                <LeadPopUpButton ElemenetType={ElemenetType.button}  ButtonClass={`btnSecondery btn `} >Talk To Our Experts</LeadPopUpButton>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    
       </section>
    );
}